import BaseModel from './BaseModel'
import handleAxiosError from '../utils/handleAxiosError'

/**
 * @todo Add types for API methods.
 */
export default class Facility extends BaseModel {

  static entity = 'facilities'
  static primaryKey = 'ID'

  declare ID: number
  declare normalizedAddress: string
  declare street: string
  declare city: string
  declare state: string
  declare zip: string

  static fields() {
    return {
      ID: this.number(null),
      normalizedAddress: this.string(''),
      street: this.string(''),
      city: this.string(''),
      state: this.string(''),
      zip: this.string(''),
    }
  }

  static lookUpByAddress(address: string) {
    const url = '/locations/lookup?address=' + encodeURIComponent(address)
    return this.api()
      .get(url, {
        save: false,
        dataTransformer: ({ data }) => {
          // The API returns the primary key as "facilityID", instead of "ID".
          return data.addresses.map((facility: any) => {
            facility.ID = facility.facilityID
            delete facility.facilityID
            return facility
          })
        },
      })
      .catch(handleAxiosError)
  }

}
